import {ReactElement} from 'react'
import {Trans} from 'react-i18next'
import {Grid} from '@material-ui/core'
import messages from '../../../../../assets/messages'
import {useStyles} from './styles'

export default function PasswordRequirements(): ReactElement {
  const classes = useStyles()

  return (
    <Grid className={classes.container} item xs={12} sm={10} lg={4}>
      <div className={classes.content}>
        <Trans {...messages.passwordRequirementsTitle}/>
        <ul className={classes.list}>
          <li><Trans {...messages.passwordRequirementsLength}/></li>
          <li><Trans {...messages.passwordRequirementsUppercaseLetter}/></li>
          <li><Trans {...messages.passwordRequirementsLowercaseLetter}/></li>
          <li><Trans {...messages.passwordRequirementsSpecialCharacter}/></li>
          <li><Trans {...messages.passwordRequirementsNumericCharacter}/></li>
        </ul>
      </div>
    </Grid>
  )
}
